export const BASE_URL = 'https://xgenious.com';
export const CANONICAL = `${BASE_URL}/products/listocean-classified-ads-listing-platform`;

export const COLOR = '#0891b2';
export const COLOR_DARK = '#164e63';
export const LIGHT_COLOR = '#ecfeff';
export const DARK_BG = '#061a2a';

export const PURCHASE_URL = 'https://codecanyon.net/item/listocean-classified-ads-listing-platform/53068796';
export const DEMO_URL = 'https://listocean.bytesed.com';
export const ADMIN_DEMO_URL = 'https://listocean.bytesed.com/admin';
export const DOCS_URL = 'https://docs.xgenious.com/docs/listocean-classified-ads-listing-platform/';
export const PRICING_URL = '#pricing';

export const REGULAR_PRICE = 29;
export const FULL_PRICE = 59;
export const FULL_ORIGINAL = 99;
export const EXCLUSIVE_PRICE = 149;
export const EXCLUSIVE_ORIGINAL = 249;

export const FULL_PRODUCT_PATH = 'listocean-bundle-pack';
export const EXCLUSIVE_PRODUCT_PATH = 'listocean-exclusive-pack';
export const INSTALL_PRODUCT_PATH = 'listocean-install-web';
export const SUPPORT_PRODUCT_PATH = 'listocean-support-6m';

export const QUICK_LINKS = [
  { label: 'Frontend Demo', href: DEMO_URL },
  { label: 'Admin Demo', href: ADMIN_DEMO_URL },
  { label: 'Documentation', href: DOCS_URL },
  { label: 'Pricing', href: PRICING_URL },
];

export const FEATURES = [
  {
    name: 'Real-Time Live Chat',
    desc: 'Connect buyers and sellers instantly via built-in live chat on every listing page. No third-party service or API key needed.',
    icon: 'chat',
  },
  {
    name: 'Google Maps Integration',
    desc: 'Location-aware listing discovery with interactive maps. Buyers filter results by city, neighbourhood, or radius — location built in from day one.',
    icon: 'map',
  },
  {
    name: 'Membership Plans',
    desc: 'Tiered membership system gives paying members featured placement, highlighted ads, and extended listing duration — driving recurring revenue.',
    icon: 'membership',
  },
  {
    name: 'Wallet & Transactions',
    desc: 'Built-in digital wallet lets users fund their account and pay for featured listings or memberships without leaving the platform.',
    icon: 'wallet',
  },
  {
    name: 'Image, Script & Google Ads',
    desc: 'Monetize with image banners, custom script embeds, and Google AdSense. Admin panel tracks impressions, clicks, countries, and devices per ad.',
    icon: 'ads',
  },
  {
    name: 'RTL + Multilingual Support',
    desc: 'Full right-to-left layout for Arabic, Hebrew, and Urdu. Edit language files from the admin panel. 700+ Google Fonts across all scripts.',
    icon: 'rtl',
  },
  {
    name: 'Guest Listing — No Signup',
    desc: 'Allow visitors to post ads without creating an account. Lower friction means more listings, which means more value for every visitor.',
    icon: 'guest',
  },
  {
    name: 'Blog Module',
    desc: 'Built-in blog with category management, SEO meta tags, and OG images. Publish guides and market news to drive organic traffic to your platform.',
    icon: 'blog',
  },
  {
    name: 'Google Analytics & SEO',
    desc: 'Native Google Analytics integration, per-page meta titles and descriptions, OG images, sitemap generation, and Google Captcha V3 — all built in.',
    icon: 'analytics',
  },
  {
    name: 'Review & Ratings System',
    desc: 'Buyers and sellers rate each other after transactions, building trust and social proof that reduces friction for new visitors.',
    icon: 'star',
  },
  {
    name: 'Role-Based Admin Permissions',
    desc: 'Multiple admin roles with granular permissions. Manage your team safely — from super admin to moderator — without exposing sensitive settings.',
    icon: 'roles',
  },
  {
    name: 'GDPR, Security & Compliance',
    desc: 'CSRF, XSS, and SQL injection prevention. Password hashing, Google Captcha V3, GDPR cookie consent, and force-SSL — security baked in by default.',
    icon: 'gdpr',
  },
];

export const PLUGINS = [
  {
    name: 'Live Chat Plugin',
    tag: 'Real-Time',
    desc: 'Enable direct messaging between buyers and listing owners right on the ad page. Reduces friction, increases conversions, and keeps all communication on-platform.',
    value: 19,
  },
  {
    name: 'Membership Plugin',
    tag: 'Revenue',
    desc: 'Offer tiered membership plans that give users premium listing placement, featured ad slots, and extended duration. Turn your free classifieds site into a subscription business.',
    value: 19,
  },
  {
    name: 'Wallet Plugin',
    tag: 'Payments',
    desc: 'Add a digital wallet so users can top up their balance and spend it on featured listings and memberships without entering payment details repeatedly.',
    value: 19,
  },
  {
    name: 'SMS Gateway Plugin',
    tag: 'Notifications',
    desc: 'Send SMS for account verification, new listing alerts, and membership expiry reminders. Compatible with all major SMS providers — Twilio, Nexmo, and more.',
    value: 19,
  },
];

export const BUILDERS = [
  {
    name: 'Page Builder',
    desc: 'Drag 30+ pre-built widgets onto any page — hero, listings grid, categories, testimonials, FAQ, and more. 3 homepage variants included.',
  },
  {
    name: 'Menu Builder',
    desc: 'Build dropdown and mega menus visually. Reorder items, add icons, and nest sub-menus — changes publish instantly to the live site.',
  },
  {
    name: 'Form Builder',
    desc: 'Create custom listing submission forms per category with text, number, email, select, checkbox, textarea, and file fields.',
  },
  {
    name: 'Widget Builder',
    desc: 'Drag-and-drop footer widget areas plus raw-HTML zones for newsletter signup, image blocks, or any custom content in footers and sidebars.',
  },
];

export const LAUNCH_STEPS = [
  {
    step: '01',
    title: 'Install on Your Server',
    desc: 'Upload ListOcean to any PHP/Laravel-compatible host or VPS, run the guided installer, and connect your database. Detailed documentation walks you through every step.',
  },
  {
    step: '02',
    title: 'Configure Categories & Locations',
    desc: 'Set up your listing categories, subcategories, and location hierarchy from the admin panel. Tailor the taxonomy to your niche — vehicles, real estate, jobs, services, or anything else.',
  },
  {
    step: '03',
    title: 'Enable Premium Plugins',
    desc: 'Activate the Live Chat, Membership, Wallet, and SMS Gateway plugins from the plugin manager. Toggle only what your business model needs — each plugin installs in one click.',
  },
  {
    step: '04',
    title: 'Go Live & Start Monetizing',
    desc: 'Publish your site, open it to listings, and start earning from featured placements, membership subscriptions, and ad banners from day one.',
  },
];

export const WHO_FOR = [
  {
    tag: 'Entrepreneurs',
    title: 'Local Marketplace Founders',
    desc: 'Launch a hyper-local classifieds site for any niche — real estate, vehicles, jobs, electronics, or services. You own the platform, the data, and all the revenue it generates. No platform commission ever.',
    fits: ['Real estate & property listings', 'Vehicle buy/sell marketplace', 'Jobs & services board'],
  },
  {
    tag: 'Community Builders',
    title: 'Neighbourhood & City Platforms',
    desc: 'Create a trusted local marketplace that your community actually uses. Built-in reviews, live chat, and verified memberships give buyers and sellers the confidence to transact locally.',
    fits: ['Hyper-local classifieds', 'City or neighbourhood deals', 'Community buy/sell groups'],
  },
  {
    tag: 'Agencies',
    title: 'Agencies & Freelance Developers',
    desc: 'Deliver fully functional classified platforms to clients in a fraction of the time of a custom build. Full source code access on the Exclusive license means you can customise and white-label for each project.',
    fits: ['Client classified site projects', 'Niche vertical marketplaces', 'White-labelled platforms'],
  },
];

export const COMPARISON_ROWS = [
  { feature: 'Pricing model',              listocean: 'One-time from $29',     osclass: 'Free + paid addons',      wordpress: 'Free + plugins',        custom: '$15K–$40K' },
  { feature: 'You own the source code',    listocean: '✓ Full Laravel',         osclass: '✓ PHP',                   wordpress: '✓ PHP',                 custom: '✓' },
  { feature: 'Monthly platform fees',      listocean: 'None',                   osclass: 'Hosting only',            wordpress: 'Hosting + plugins',     custom: 'None' },
  { feature: 'Built-in live chat',         listocean: '✓ Plugin included',      osclass: '✗ Separate service',      wordpress: '✗ Separate plugin',     custom: 'Custom build' },
  { feature: 'Membership system',          listocean: '✓ Plugin included',      osclass: 'Paid addon',              wordpress: 'Plugin needed',         custom: 'Custom build' },
  { feature: 'Wallet & payments',          listocean: '✓ Plugin included',      osclass: 'Paid addon',              wordpress: 'WooCommerce + plugin',  custom: 'Custom build' },
  { feature: 'No-code drag & drop',        listocean: '✓ 4 builders',           osclass: '✗',                       wordpress: 'Theme + Elementor',     custom: 'Custom build' },
  { feature: 'Google Maps built-in',       listocean: '✓',                      osclass: '✓ Basic',                 wordpress: 'Plugin needed',         custom: 'Custom build' },
  { feature: 'GDPR compliance built-in',   listocean: '✓',                      osclass: '✗',                       wordpress: 'Plugin needed',         custom: 'Custom build' },
  { feature: 'Time to launch',             listocean: 'Same day',               osclass: 'Days',                    wordpress: 'Days',                  custom: '3–6 months' },
];

export const TRUST_SIGNALS = [
  { label: 'Built on Laravel 10', detail: 'PHP 8.1+ · MySQL 8 · Bootstrap 5' },
  { label: 'Full Source Code', detail: 'You own and can modify it' },
  { label: 'Lifetime Updates', detail: 'Free on every license' },
  { label: 'One-Time Price', detail: 'No monthly platform fees' },
];

export const FAQS = [
  {
    question: 'What is ListOcean?',
    answer:
      'ListOcean is a classified ads and listing platform built on the Laravel PHP framework. It lets you launch a fully featured classifieds website where users can post, search, and respond to listings across any category — real estate, vehicles, jobs, electronics, or services. It ships with live chat, Google Maps, a membership system, a digital wallet, multiple ad formats, and 4 drag & drop builders — for a one-time price with no monthly fees.',
  },
  {
    question: 'What categories and types of listings can ListOcean support?',
    answer:
      'ListOcean supports unlimited categories and subcategories, all configurable from the admin panel. Common setups include: property listings (rent, sale, commercial), vehicle classifieds (cars, bikes, trucks), job boards, electronics buy/sell, services, pets, and general merchandise. You define the taxonomy, and each category can have custom listing fields created with the form builder.',
  },
  {
    question: 'What premium plugins are included in the Everything Bundle and Exclusive Pack?',
    answer:
      'Both the Everything Bundle ($59) and Exclusive Pack ($149) include all four premium plugins: Live Chat Plugin ($19 value) — real-time buyer-to-seller messaging on listing pages; Membership Plugin ($19 value) — tiered plans with featured placement and benefits; Wallet Plugin ($19 value) — digital wallet for featured listing payments; and SMS Gateway Plugin ($19 value) — SMS notifications for registration and alerts. Individually these cost $76. The Regular License does not include any plugins.',
  },
  {
    question: 'How does the live chat system work?',
    answer:
      'The Live Chat Plugin enables real-time messaging between a listing viewer and the ad owner, directly on the listing detail page. Buyers click a chat button, a message thread opens, and both parties receive notifications. All chats are logged in the admin panel and both users can access their chat history from their dashboards. No external chat service or API key is required.',
  },
  {
    question: 'How does the membership system generate revenue?',
    answer:
      'The Membership Plugin lets you create tiered plans (Silver, Gold, Platinum, etc.) with configurable benefits: number of active listings, featured placement priority, listing duration, badge display, and category access. Users purchase memberships through the wallet or direct payment. Recurring or one-time membership pricing is supported. The admin panel shows active members, revenue, and plan analytics.',
  },
  {
    question: 'What are the drag & drop builders and what can I build with them?',
    answer:
      'ListOcean includes four no-code builders: a Page Builder with 30+ pre-built widgets (hero, listing grid, categories, testimonials, FAQ), a Menu Builder for dropdowns and mega menus, a Form Builder for per-category listing fields, and a Widget Builder for footer zones. All changes publish instantly — no code or FTP access required.',
  },
  {
    question: 'Is ListOcean GDPR compliant?',
    answer:
      'Yes. ListOcean includes a configurable GDPR cookie consent banner with category-level preferences (essential, analytics, marketing). Users can accept or decline cookie categories, and their preferences are stored. The admin panel lets you configure what each consent category covers. This satisfies standard EU GDPR cookie requirements without needing a separate consent plugin.',
  },
  {
    question: 'What are the server requirements to install ListOcean?',
    answer:
      'ListOcean requires PHP 8.1 or higher, MySQL 5.7 or higher (MySQL 8 recommended), Composer 2, and mod_rewrite enabled. It runs on any standard PHP/Laravel-compatible hosting — shared cPanel hosting, VPS, or cloud servers including DigitalOcean, AWS, or Vultr. Minimum 512 MB RAM is recommended; 1 GB+ for production sites with active traffic.',
  },
  {
    question: 'What is the difference between the Regular, Full Package, and Exclusive licenses?',
    answer:
      'Regular ($29 on CodeCanyon) — base script, one domain, no plugins. Everything Bundle ($59) — all four premium plugins included, 6 months support. Exclusive Pack ($149, normally $249) — all plugins plus full source code modification rights, branding removal, professional installation, and 6 months priority support. Agencies and developers who need to customise or white-label the platform should choose the Exclusive Pack.',
  },
  {
    question: 'Is ListOcean a good choice for building a classified ads platform in 2025?',
    answer:
      'ListOcean is one of the most feature-complete self-hosted classified ads scripts available. It runs on Laravel 10 — the most-starred PHP framework on GitHub — and ships production-ready with live chat, Google Maps, memberships, a digital wallet, Google Ads support, RTL multilingual support, GDPR compliance, and 4 drag-and-drop builders. Pricing starts at $29 for the base script, with full source code included on every license.',
  },
  {
    question: 'Can I see a live demo before buying?',
    answer:
      'Yes. A full live frontend demo is at listocean.bytesed.com. Log in to the admin panel at listocean.bytesed.com/admin with username super_admin and password 12345678 to test the page builder, category management, plugin settings, and ad performance analytics. A user account is also available: username test_user, password 12345678. Documentation is available at docs.xgenious.com.',
  },
];
